import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { ModalSize } from '../../utils/constants/StyleConstant';

export interface AlertModalData extends React.PropsWithChildren<{}> {
  show?: boolean;
  title?: string;
  closeText?: string;
  modalSize?: ModalSize;
  onClose: () => void;
  elementRef?: any;
  elementID?: string;
  overflowYAuto?: boolean;
  backdropClassName?: string;
}

export function AlertModal(props: AlertModalData): React.FunctionComponentElement<AlertModalData> {
  const {
    show,
    title,
    closeText,
    modalSize,
    onClose,
    elementRef,
    children,
    elementID = 'alert-modal',
    overflowYAuto = false,
    backdropClassName,
  } = props;
  return (
    <>
      {
        <Modal
          show={show}
          dialogClassName={modalSize && modalSize !== ModalSize.MD ? '' : 'modal-md'}
          size={modalSize && modalSize !== ModalSize.MD ? modalSize : undefined}
          backdropClassName={backdropClassName}
          onHide={onClose}
        >
          {title && (
            <Modal.Header>
              <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
          )}
          <Modal.Body className={`${overflowYAuto ? 'overflow-y-auto' : ''}`} ref={elementRef}>
            {children}
          </Modal.Body>
          <Modal.Footer>
            <div className="float-right">
              <Button id={`${elementID}-close-button`} variant="primary" onClick={onClose}>
                {closeText ? closeText : 'Close'}
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
      }
    </>
  );
}
